import { memo, useMemo } from "react";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { HStack } from "@design-system/HStack/HStack";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const AuditActorCell = memo(function AuditActorCell({
    userId,
}: {
    userId: number | null;
}) {
    const { data: members = [] } = useCurrentWorkspaceMembers();
    const member = useMemo(
        () =>
            userId != null
                ? (members.find((m) => m.user.id === userId) ?? null)
                : null,
        [userId, members],
    );

    return (
        <ViewTableCell>
            {member ? (
                <HStack gap={8} align="center">
                    <UserAvatar user={member.user} size="sm" aria-hidden />
                    {member.user.name}
                </HStack>
            ) : (
                <span className="text-muted">-</span>
            )}
        </ViewTableCell>
    );
});
